module.exports = __webpack_public_path__ + "media/careers_screens@sm-aedab59a8161d63783d844f51edca1c6.png";